import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languagedetector from 'i18next-browser-languagedetector';
import translationsEN from './translations/en/common.json';
import translationsFA from './translations/fa/common.json';

const resources = {
  en: {
    translation: translationsEN,
  },
  fa: {
    translation: translationsFA,
  },
};

i18n
  .use(initReactI18next)
  .use(languagedetector)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fa'],
    debug: true,
    returnEmptyString: true,
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    },
    detection: {
      lookupFromPathIndex: 1,
      order: ['path'],
    },
  });

export default i18n;
